import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 16 16',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <path
      fill={fill}
      d="M7,11H9v2H7ZM7,5H9v5H7Zm.73-3.86L0,14.72c-.12.19,0,.28.27.28H15.68c.23,0,.4-.09.27-.28L8.27,1.14A.33.33,0,0,0,7.73,1.14Z"
    />
  </svg>
);
export default SVG;
